export * from './fixturesSummaryBlockMatchCard.types';
export { default as FixturesSummaryBlockMatchCard } from './fixturesSummaryBlockMatchCard.component';
